import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navbar, Header, Footer, Accordion } from "../components";
import { faqAccordion } from "../constants";

import { styles } from "../styles";

const FaqPage = () => {
  const { t } = useTranslation();
  const [accordions, setAccordion] = useState(faqAccordion);
  const toggleAccordion = (accordionkey) => {
    const updatedAccordions = accordions.map((accord) => {
      if (accord.key === accordionkey) {
        return { ...accord, isOpen: !accord.isOpen };
      } else {
        return { ...accord, isOpen: false };
      }
    });

    setAccordion(updatedAccordions);
  };

  return (
    <>
      <Navbar />
      <Header title="FAQ" />
      <main className={`${styles.paddingX} flex flex-col py-20`}>
        <div className="space-y-4">
          {accordions.map((accordion, index) => (
            <Accordion
              key={accordion.key}
              title={t(`faq.${accordion.key}.title`)}
              data={t(`faq.${accordion.key}.data`)}
              isOpen={accordion.isOpen}
              list={index === 2 ? t("faq.3.list") : []}
              toggleAccordion={() => toggleAccordion(accordion.key)}
            />
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
};

export default FaqPage;
